import { Component, OnInit } from '@angular/core';
import { MemService } from '@partners/utils';
import { environment } from '../environments/environment';

@Component({
  selector: 'partners-root',
  template: `
    <application-view *appInitializer progressTracker gtmInjectScripts class="application-view"></application-view>
    <ng-container *ngIf="isDevMode">
      <partners-debugger></partners-debugger>
    </ng-container>
  `,
  host: {
    class: 'partners-root'
  }
})
export class AppHostComponent implements OnInit {
  title = 'wallet';

  isDevMode: boolean = false;

  constructor(private mem: MemService) {
    this.isDevMode = environment.isDevMode;
    // if (environment) {
    //   this.isDevMode = environment.isDevMode;
    // }
  }

  ngOnInit(): void {
    this.mem.injectMemScripts();
  }
}
